import { render, staticRenderFns } from "./Trem.vue?vue&type=template&id=63b1a6ce&scoped=true"
import script from "./Trem.vue?vue&type=script&lang=js"
export * from "./Trem.vue?vue&type=script&lang=js"
import style0 from "./Trem.vue?vue&type=style&index=0&id=63b1a6ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b1a6ce",
  null
  
)

export default component.exports